import { render, staticRenderFns } from "./BankFinancing-requirements-from-buyer.vue?vue&type=template&id=4b9a5c21&"
import script from "./BankFinancing-requirements-from-buyer.vue?vue&type=script&lang=js&"
export * from "./BankFinancing-requirements-from-buyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports